import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setReportAnalyticsPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useReportAnalyticsSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getReportAnalyticsSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.report_analytics_page?.report_analytics_section}`);
      console.log("🚀 ~ getReportAnalyticsSectionJson ~ data:", response);
      console.log("🚀 ~ getReportAnalyticsSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setReportAnalyticsPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Report Analytics section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getReportAnalyticsSectionJson();
  }, [getReportAnalyticsSectionJson]);

  return {
    data,
    loading,
    error,
    getReportAnalyticsSectionJson,
    fetchOnMount,
    refetch: getReportAnalyticsSectionJson
  };
};

export default useReportAnalyticsSection;
